<template>
    <div>
        <PageTitle :page="'Dashboard'" :title="titles.profile"/>
        <profile/>
    </div>
</template>

<script>
    import Profile from './Form';
    import PageTitle from '@/components/common/PageTitle';
    import {titles} from '../../utils/general/titles.js';

    export default {
        name: 'index',
        components: {PageTitle, Profile},
        data() {
            return {
                titles
            };
        }
    };
</script>

<style scoped></style>
